import { render, staticRenderFns } from "./subplaces.vue?vue&type=template&id=3d0c5e8b&scoped=true&"
import script from "./subplaces.vue?vue&type=script&lang=js&"
export * from "./subplaces.vue?vue&type=script&lang=js&"
import style0 from "./subplaces.vue?vue&type=style&index=0&id=3d0c5e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c5e8b",
  null
  
)

export default component.exports